export default "__VITE_ASSET__ebskQIWW__"